import React, { useEffect, useRef, useState } from 'react';

function XEmbedSimple({ url, maxWidth = 480 }) {
  const containerRef = useRef(null);
  const [error, setError] = useState(null);

  // Sanitize the input URL
  let cleanUrl = url.trim();
  if (cleanUrl.startsWith('@')) cleanUrl = cleanUrl.slice(1);
  cleanUrl = cleanUrl.replace(/\\\//g, '/');
  const normalizedUrl = cleanUrl.replace('://x.com/', '://twitter.com/');

  useEffect(() => {
    // Clear previous content
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
    }

    // Create blockquote element
    const blockquote = document.createElement('blockquote');
    blockquote.className = 'twitter-tweet';
    blockquote.setAttribute('data-dnt', 'true');
    blockquote.setAttribute('data-theme', 'light');
    blockquote.style.maxWidth = `${maxWidth}px`;
    blockquote.style.width = '100%';
    blockquote.style.margin = '0 auto';

    const a = document.createElement('a');
    a.href = normalizedUrl;
    blockquote.appendChild(a);

    if (containerRef.current) {
      containerRef.current.appendChild(blockquote);
    }

    // Load Twitter widget
    const loadTwitterScript = () => {
      return new Promise((resolve, reject) => {
        if (window.twttr && window.twttr.widgets) {
          resolve(window.twttr);
          return;
        }
        const script = document.createElement('script');
        script.src = 'https://platform.twitter.com/widgets.js';
        script.async = true;
        script.onload = () => {
          if (window.twttr && window.twttr.widgets) {
            resolve(window.twttr);
          } else {
            reject(new Error('Twitter widget failed to load'));
          }
        };
        script.onerror = () => reject(new Error('Failed to load Twitter widget script'));
        document.body.appendChild(script);
      });
    };

    loadTwitterScript()
      .then(twttr => twttr.widgets.load(containerRef.current))
      .catch(err => setError(err.message));

    // No cleanup needed, let Twitter own the DOM
  }, [normalizedUrl, maxWidth]);

  if (error) {
    return (
      <div style={{
        padding: '20px',
        background: '#f8f8f8',
        borderRadius: '8px',
        textAlign: 'center',
        color: '#666'
      }}>
        Failed to load X post. <a href={normalizedUrl} target="_blank" rel="noopener noreferrer">View on X</a>
      </div>
    );
  }

  return (
    <div ref={containerRef} style={{ width: '100%', maxWidth, margin: '0 auto' }} />
  );
}

export default XEmbedSimple; 